import { usersPageOpenedEvent } from '../../common/bi-events/users-events/users-page-opened-event';

export const usersEventMap = {
  ...usersPageOpenedEvent,
};
